import React, { FC } from "react";
import { PageAlert } from "@xapp/components";

export const AppLiveWarning: FC<{}> = () => {
    return (
        <PageAlert background="orange">
            <h2>Edit with care!</h2>

            <p>
                Changes made to these settings will be live immediately, so please make certain that everything is
                correct before saving.
            </p>
        </PageAlert>
    );
};
